import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, Table, Button, message } from "antd";
import moment from "moment";
import axios from "axios";
import { Translate } from "react-translated";
import F from "../../Functions";
import { cloneDeep } from "lodash";
import AssociateUserTags from "../../components/associate-user-tags";

class MergeCustomers extends Component {
  state = {
    loading: false,
    bfiles: [],
    agency_id: null,
    user: this.props.auth.user,
    search: "",
    selectedRowIndexes: [], // [1,3] ==>> indexes
  };
  componentDidMount = () => {
    // Find Agency ID
    axios.get("/api/user").then((res) => {
      const u = res.data;
      let agency_id = null;
      if (
        u.user_agency_assoc &&
        u.user_agency_assoc.length > 0
      ) {
        agency_id = u.user_agency_assoc[0].agency_id || null;
      }

      const duplicateCustomers = window.localStorage.duplicateCustomers;
      // const customersToMerge = window.localStorage.customersToMerge;

      // const mergeCustomerData = JSON.parse(duplicateCustomers).concat(
      //   JSON.parse(customersToMerge)
      // );

      // get unique customers data
      // const uniqueMergeCustomerData = F.removeDuplicateFromArray(
      //   JSON.parse(duplicateCustomers)
      // );

      // update on view
      this.setState({
        // bfiles: uniqueMergeCustomerData,
        bfiles: JSON.parse(duplicateCustomers),
        agency_id,
      });
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({
      selectedRowIndexes: selectedRowKeys,
    });
  };

  requestMergeCustomer = (primaryBfileID, linkedBfileIDsArray) => {
    const { agency_id } = this.state;

    this.setState({ loading: true });
    axios
      .post("/api/associated_bfiles", {
        agency_id: `${agency_id}`,
        primary_id: `${primaryBfileID}`,
        secondary_ids: linkedBfileIDsArray,
      })
      .then((res) => {
        this.setState({ loading: false });
        // this.props.history.push("/dashboard");

        // get state from 2nd route param
        // const state = this.props.location.state;
        const queryParams = new URLSearchParams(this.props.location.search);
        const lastSearch = queryParams.get('lastSearch');  // Retrieve query param
        // console.log('Received lastSearch:', lastSearch);

        message.success(res.data.results)
        if (lastSearch) {
          this.props.history.push(`/search-duplicate-customers?lastSearch=${lastSearch}`);
          // this.props.history.push("/search-duplicate-customers", {
          //   lastSearch: state.lastSearch,
          // });
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        F.showAndHandleServerError(error);
      });
  };

  mergeCustomer = () => {
    const { selectedRowIndexes } = this.state;

    // clone all bfiles showing on screen as different referrence
    const copyBFles = cloneDeep(this.state.bfiles);

    // selected Bfile Index
    const selectedBfileIndex = selectedRowIndexes[0];

    // selected Bfile ID
    const primaryBfileID = copyBFles[selectedBfileIndex].id;

    // remove selected Bfile from all listed bfiles
    copyBFles.splice(selectedBfileIndex, 1);

    // extract (remaining or linked) Bfile id's from bfile list and convert into comma separated
    // const linkedBfileIDs = copyBFles.reduce(
    //   (previousValue, currentValue) =>
    //     previousValue == ""
    //       ? currentValue.id
    //       : `${previousValue},${currentValue.id}`,
    //   ""
    // );

    // make associated bfile ids to array
    const linkedBfileIDsArray = copyBFles.map((s) => s.id);

    F.log("NOOR primaryBfileID => " + primaryBfileID);
    F.log("NOOR linkedBfileIDsArray => " + linkedBfileIDsArray);
    F.log("NOOR agency_id => " + this.state.agency_id);

    // request Merge Customer
    this.requestMergeCustomer(primaryBfileID, linkedBfileIDsArray);
  };

  render() {
    const { loading, bfiles, selectedRowIndexes } = this.state;

    let columns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Created Date",
        dataIndex: "created_on",
        key: "created_on",
      },
      {
        title: "Agency Name",
        dataIndex: "agency_name",
        key: "agency_name",
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
      },
      {
        title: "Associate Users",
        dataIndex: "associate_users",
        key: "associate_users",
        render: (associate_users) => (
          <AssociateUserTags associate_users={associate_users} />
        ),
      },
    ];

    for (var i = 0; i < columns.length; i++) {
      columns[i].title = <Translate text={columns[i].title} />;
    }

    const data = [];
    for (let i = 0; i < bfiles.length; i++) {
      let bfile = bfiles[i];
      let stage = "";
      let today = new Date();
      if (
        bfile.vob_attempted == null &&
        bfile.vob_completed == null &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Claimed";
      }
      if (
        (bfile.onboarding_id == null ||
          bfile.onboarding_user_type != "VONBOARDER") &&
        new Date(bfile.expiration_date) < today
      ) {
        stage = "Due Calls";
      }
      if (
        bfile.vob_attempted == 1 &&
        bfile.vob_completed == null &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Attempted Calls";
      }
      if (
        (bfile.onboarding_id == null ||
          bfile.onboarding_user_type != "VONBOARDER") &&
        new Date(bfile.expiration_date) >= today
      ) {
        stage = "Upcoming Calls";
      }
      if (
        bfile.vob_completed == 1 &&
        bfile.not_interested == 0 &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Completed Calls";
      }
      if (
        bfile.vob_completed == 1 &&
        bfile.not_interested == 1 &&
        bfile.onboarding_user_type == "VONBOARDER"
      ) {
        stage = "Not Reached Archived";
      }

      let bfile_name = bfile.first_name + " " + bfile.last_name;
      if (!bfile.last_bfile) {
        bfile_name = (
          <div style={{ paddingLeft: 20 }}>
            {bfile.first_name + " " + bfile.last_name}
          </div>
        );
      }

      data.push({
        name: bfile_name,
        created_on: moment(new Date(bfile.date)).format("MM/DD/YYYY"),
        agency_name: bfile.agency_name,
        status: stage,
        phone: bfile.phone,
        email: bfile.email,
        // associate_users: bfile.Associated_bfiles.concat(
        //   bfile.Associated_bfiles
        // ),
        associate_users: bfile.Associated_bfiles,
      });
    }

    const rowSelection = {
      selectedRowKeys: selectedRowIndexes,
      onChange: this.onSelectChange,
      type: "radio",
    };

    F.log("selectedRowIndexes==>>", JSON.stringify(selectedRowIndexes));
    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Translate text={`Select Primary`} />
            </div>
          }
          className="tableCard"
          loading={loading}
        >
          {selectedRowIndexes.length > 0 ? (
            <div className="toolbarButtons">
              <Button type="default"
                className="borderRadius-28"
                onClick={this.mergeCustomer}>
                <Translate text={`Merge & Finish`} />
              </Button>
            </div>
          ) : null}
          <Table
            columns={columns}
            dataSource={data}
            bordered={false}
            pagination={false}
            rowSelection={rowSelection}
            locale={{ emptyText: "No Data To Show" }}
          />
        </Card>
      </div>
    );
  }
}

export default MergeCustomers;



// WEBPACK FOOTER //
// ./src/scenes/MergeCustomers/index.js